import { gql } from 'graphql-tag'
import queryPageFields from '../../../core/data-layer/pages/page/query-page-fields'
import { fragmentModuleUsp, fragmentModuleNavigationLink } from '../../../core/data-layer/modules/fragments'
import { fragmentBlockFaqGroup, fragmentBlockCallToAction } from '../../../core/data-layer/blocks/fragments'

export default gql`
    ${fragmentModuleUsp}
    ${fragmentModuleNavigationLink}
    ${fragmentBlockFaqGroup}
    ${fragmentBlockCallToAction}
    query($slug: String!, $locale: String!, $preview: Boolean!) {
        page: pagePricingCollection(limit: 1, where: { slug: $slug }, locale: $locale, preview: $preview) {
            items {
                ${queryPageFields}
                description {
                    json
                }
                link {
                    ...ModuleNavigationLinkFragment
                }
                linkText
                uspsCollection(limit: 4) {
                    items {
                        ...ModuleUspFragment
                    }
                }
                cardsCollection(limit: 4) {
                    items {
                        sys {
                            id
                        }
                    }
                }
                faq {
                    ...BlockFaqGroupFragment
                }
                callToAction {
                    ...BlockCallToActionFragment
                }
            }
        }
        paymentMethods: pagePaymentMethodsDetailCollection(limit: 200, locale: $locale, preview: $preview, order: name_ASC ) {
            items {
                sys {
                    id
                }
                paymentMethod {
                    sys {
                        id
                    }
                }
                pricingRefundFee
                pricingFee
                pricingFeeTypeInterchange
                pricingSetShopperCountryGlobal
                pricingFeeExplanationTitle
                pricingFeeExplanationText
                pricingRefundFeeExplanationTitle
                pricingRefundFeeExplanationText
                pricingFeeCountryTable
            }
        }
    }
`
